import styles from "shared/ContentList/ContentList.module.css";

import Link from "next/link";
import { TimeRelative } from "gui/time/time";
import { Icon } from "gui/icon/icon";
import Stars from "gui/BrowseQueriesPage/List/QueryStar";

import type { QueryOnProfileType } from "./queryItemOnProfile";
import { Tags } from "../../tags/tags";

interface Props {
  owner: { handle: string };
  queries: QueryOnProfileType[];
}

export default function QueriesListOnProfile(props: Props) {
  return (
    <table className={styles.table}>
      <tbody>
        {props.queries.map((query) => (
          <tr key={query.id}>
            <td className={styles.avatarColumn}>
              <Icon icon="query" />
            </td>
            <td>
              <div className={styles.multiline}>
                <div className={styles.nameAndTags}>
                  <Link href={`/queries/${query.id}`}>
                    <a className={styles.contentName}>{query.name}</a>
                  </Link>
                  {query.tags.length > 0 && (
                    <Tags
                      className={styles.tags}
                      slug="queries"
                      tags={query.tags.slice(0, 5)}
                    />
                  )}
                </div>
                <div className={styles.userName}>
                  <span>Created by</span>
                  <Link href={`/${props.owner.handle}`}>
                    <a>@{props.owner.handle}</a>
                  </Link>
                  <TimeRelative>{query.created_at}</TimeRelative>
                </div>
              </div>
            </td>
            <td>
              <Stars
                query_id={query.id}
                stars={query.favoriteCount}
                isFavorite={false}
                enableFavoriting={false}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
